import router from "@/router";

export const currentRouteIsExternal = ():boolean => {
    const routeName = router.currentRoute.value.name;
    return routeName
        ? routeName.toString().toLowerCase().includes("external")
        : false;
}